export enum InventoryHoldStatus {
  ACTIVE = 'ACTIVE',
  RELEASED = 'RELEASED',
  EXPIRED = 'EXPIRED',
  CONSUMED = 'CONSUMED',
}
